import React, { Component } from 'react'

export default class Contact extends Component {
    render() {
        return (
            <div>
                <p>We will contact you!</p>
            </div>
        )
    }
}
